// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__14o6G","title":"AfterBackImages_title__2-XRL","images":"AfterBackImages_images__3rPIB"};